import _ from 'lodash';;
import { observable, action, computed } from 'mobx';

export default class Genre {
	store = null;

	constructor (store, data) {
		this.store = store;

		if (_.isEmpty(data)) {

			return;
		}

		this.update(data);
	}

	_id = null;
	get id () {
		return this._id;
	}

	set id (id) {
		this._id = id;
	}

	/**
	 * Observables & Computeds
	 */

	@observable
	_label = '';

	@computed
	get label () {
		return this._label;
	}

	set label (label) {
		this._label = label;
	}

	@observable
	_artwork = '';

	@computed
	get artwork () {
		return this._artwork;
	}

	set artwork (artwork) {
		this._artwork = artwork;
	}

	@computed
	get serialized () {
		return {
			_id: this._id,
			label: this._label,
			artwork: this._artwork
		};
	}

	/**
	 * Actions
	 */

	@action.bound
	async save (opts) {
		await this.store.saveGenre(this, opts);
	}

	@action.bound
	async delete () {
		this.store.deleteGenre(this);
	}

	@action
	update ({ _id, label, artwork}) {
		this.id = _.defaultTo(_id, this.id);
		this.label = _.defaultTo(label, this.label);
		this.artwork = _.defaultTo(artwork, this.artwork);
	}
}
